import format from 'string-format';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import Avatar from './Avatar';
import TrackPhoneNumber from './TrackPhoneNumber';
import resx from '../../utilities/resx';
import { RESX_GLOBAL } from '../../Constants';
import GeneralUtility from '../../utilities/generalUtility';
import ConnectButton from './ConnectButton';
import UserSearch from '../../API/UserSearch';

const UserInfo = props => {
    const [userInfo, setUserInfo] = useState({});
    const [placeholder, setPlaceholder] = useState(true);
    const [fallbackMessage, setFallbackMessage] = useState(false);
    const isOwner =
        _path(['RESAAS', 'User2', 'WebsiteId'], window) === props.WebsiteId ||
        _path(['RESAAS', 'User2', 'UserId'], window) === props.UserId ||
        _path(['RESAAS', 'User2', 'DomainUrl'], window).split('/')[1] === props.Domain;
    useEffect(() => {
        let payload;
        if (props.WebsiteId) {
            payload = { WebsiteId: props.WebsiteId };
        } else if (props.UserId) {
            payload = { UserId: props.UserId };
        } else if (props.Domain) {
            payload = { Domain: props.Domain };
        }
        const getUserDetails = UserSearch.search(payload);

        getUserDetails.request
            .then(response => {
                if (_path(['data', 'Data'], response) && response.data.Data.length > 0) {
                    const userData = response.data.Data[0];
                    userData.addressFormatted = userData.Province ? `, ${userData.Province}, ${userData.Country}` : '';
                    
                    if (_path(['EnhancedProfile', 'StartedIn'], userData)) {
                        const yearExp = new Date().getFullYear() - parseInt(userData.EnhancedProfile.StartedIn, 10);
                        if (yearExp > 1) {
                            userData.YearsExpStr = format(
                                `{0} Years Experience`,
                                yearExp
                            );
                        } else {
                            userData.YearsExpStr = '1 Year of Experience';
                        }

                    }
                    if (userData.Phone) {
                        userData.phoneNumber = userData.Phone;
                    }
                    if (userData.AwardedReferrals) {
                        userData.AwardedReferralsStr = format(
                            RESAAS.Localization.Global.USER_INFO_REFERRAL_AWARDED,
                            userData.AwardedReferrals
                        );
                    }
                    if (userData.ListingActiveCount || userData.ListingComingSoonCount) {
                        userData.ListingActiveCountStr = format(
                            RESAAS.Localization.Global.USER_INFO_ACTIVE_LISTINGS,
                            userData.ListingActiveCount + userData.ListingComingSoonCount
                        );
                    }
                    if (!userData.Phone && userData.OfficePhone) {
                        userData.phoneNumber = userData.OfficePhone;
                    }

                    setPlaceholder(false);
                    setUserInfo(userData);
                   
                } else {
                    throw new Error();
                }
            })
            .catch(error => {
                GeneralUtility.logWebRequestFailure(error, `fetch user info from user info tooltip`);
                setPlaceholder(false);
                setFallbackMessage(true);
            });
    }, []);

    return (
        <React.Fragment>
            {' '}
            <div className="re-userinfo-container">
                {placeholder ? (
                    <React.Fragment>
                        <div className="re-userinfo-avatar">
                            <div className="re-placeholder-avatar" />
                        </div>
                        <div className="re-userinfo-details">
                            <div className="re-userinfo-item">
                                <div className="re-placeholder-text" />
                                <div className="re-placeholder-text" />
                                <div className="re-placeholder-text" />
                            </div>
                            <div className="re-userinfo-item">
                                <div className="re-placeholder-text" />
                                <div className="re-placeholder-text" />
                                <div className="re-placeholder-text" />
                            </div>
                            <div className="re-userinfo-item">
                                <div className="re-placeholder-btn" />
                                <div className="re-placeholder-btn" />
                                <div className="re-placeholder-btn" />
                            </div>
                        </div>
                    </React.Fragment>
                ) : null}
                {userInfo.UserId ? (
                    <React.Fragment>
                        <div className="re-userinfo-avatar">
                            {' '}
                            <a href={`/${userInfo.Domain}`} itemProp="url">
                                <Avatar
                                    websiteId={typeof WebsiteId === 'number' ? userInfo.WebsiteId : undefined}
                                    displayName={`${userInfo.Firstname} ${userInfo.Lastname}`}
                                    size="lg"
                                    imageAttributes={{ itemProp: 'image' }}
                                    hasProfileBadge={userInfo.IsPremium}
                                    hasPremiumPlusBadge={userInfo.IsPremiumPlus}
                                    src={
                                        typeof userInfo.ProfileImageUrl === 'string'
                                            ? userInfo.ProfileImageUrl
                                            : undefined
                                    }
                                />
                            </a>
                        </div>
                        <div className="re-userinfo-details">
                            <div className="re-userinfo-item">
                                {' '}
                                <a href={`/${userInfo.Domain}`} itemProp="url">
                                    <div className="re-userinfo-name notranslate" itemProp="name">{`${userInfo.Firstname} ${
                                        userInfo.Lastname
                                    }`}</div>
                                </a>
                                <ul className="re-userinfo-detail notranslate">
                                    <li>@{userInfo.Domain.split('/')[0]}</li>
                                    {userInfo.Firm ? (
                                        <li className="re-userinfo-firm" data-testid="firmlink">
                                            {userInfo.Firm}
                                        </li>
                                    ) : null}
                                </ul>
                                {userInfo.City ? (
                                    <div itemProp="city" itemScope itemType="http://schema.org/PostalAddress">
                                        {userInfo.City}
                                        {userInfo.addressFormatted}
                                    </div>
                                ) : null}
                            </div>
                            {userInfo.YearsExpStr || userInfo.AwardedReferralsStr || userInfo.ListingActiveCountStr ? (
                                <ul className="re-userinfo-item">
                                    {userInfo.YearsExpStr ? <li>{userInfo.YearsExpStr}</li> : null}
                                    {userInfo.AwardedReferralsStr ? <li>{userInfo.AwardedReferralsStr}</li> : null}
                                    {userInfo.ListingActiveCountStr ? <li>{userInfo.ListingActiveCountStr}</li> : null}
                                </ul>
                            ) : null}
                            <div className="re-userinfo-item">
                                <a
                                    href={`/inbox?UserId=${userInfo.UserId}&WebsiteId=${
                                        userInfo.WebsiteId
                                    }&FirstName=${encodeURIComponent(userInfo.Firstname)}&LastName=${encodeURIComponent(
                                        userInfo.Lastname
                                    )}`}
                                    className="re-btn re-btn-small re-btn-subtle re-btn-full-width"
                                    data-mixpanel-name="Intent"
                                    data-mixpanel-type="Start a Conversation Button"
                                >
                                    {resx(RESX_GLOBAL, 'SENDIMBUTTON_TEXT')}
                                </a>

                                {userInfo.phoneNumber ? (
                                    <TrackPhoneNumber
                                        phoneNumber={userInfo.phoneNumber}
                                        dataContext="user tooltip"
                                        userId={userInfo.UserId}
                                    />
                                ) : null}

                                <ConnectButton
                                    userId={userInfo.UserId}
                                    displayName={`${userInfo.Firstname} ${userInfo.Lastname}`}
                                    mixpanelElement="user info tooltip"
                                    black={true}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                ) : null}
                {fallbackMessage ? (
                    <div className="re-userinfo-fallback-message">
                        <a
                            href={`/${props.Domain}`}
                            className="re-btn re-btn-small re-btn-subtle re-btn-full-width"
                            data-testid="userdomain"
                            dangerouslySetInnerHTML={{
                                __html: format(resx(RESX_GLOBAL, 'USER_PROFILE_POPUP_MESSAGE'), props.FirstName)
                            }}
                        />
                    </div>
                ) : null}
            </div>
        </React.Fragment>
    );
};

UserInfo.propTypes = {
    UserId: PropTypes.string,
    WebsiteId: PropTypes.number,
    Domain: PropTypes.string,
    FirstName: PropTypes.string
};
export default UserInfo;
